import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import A from '../A'
import Collapsable from '../Collapsable'

export const WrapperCollapsable = styled(Collapsable)`
  & .collapsable-content {
    max-width: ${({ theme }) => `${theme.sizes.mangerBougerDesktop / 10}rem`};
  }
`

export const Inner = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${mq(sizes.boxContent)} {
    flex-direction: row;
    padding-bottom: 3rem;
  }
`

export const Carousel = styled.section`
  flex-shrink: 0;
  width: 100%;
  max-width: 62.5rem;

  @media ${mq(sizes.desktop)} {
    margin-bottom: 0;
  }
`

export const Introduction = styled.section`
  width: 100%;
  margin-top: 4rem;

  @media ${mq(sizes.boxContent)} {
    margin-left: 4rem;
    margin-top: 0;
  }
`

export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.text_medium_16}
  margin: 0 0 2.5rem 0;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_medium_18}
  }
`

export const Description = styled.p<{ $showMore: boolean }>`
  ${({ theme }) => theme.textStyles.text_16}
  max-height: ${({ $showMore }) => ($showMore ? '100rem' : '5.2rem')};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_18}
    max-height: ${({ $showMore }) => ($showMore ? '100rem' : '24rem')};
  }
`

export const SeeMore = styled(A)`
  display: flex;
  margin: 2rem 0;

  @media ${mq(sizes.mangerBougerTablet + 50)} {
    display: none;
  }
`
